/* eslint-disable prefer-arrow/prefer-arrow-functions */
import Dexie from 'dexie';
import { config } from './confing';
import { BlobImage } from './models/image.model';

export class ImageDB extends Dexie {
  public images: Dexie.Table<BlobImage, string>;

  constructor() {
    super('ImageDB');
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const db = this;
    //
    // Define tables and indexes
    //
    db.version(config.db).stores({
      images: '&url'
    });

    // Let's physically map BlobImage class to image table.
    db.images.mapToClass(BlobImage);
  }
}

export const db: ImageDB = new ImageDB();

/**ImageDB
 * Delete the entire database
 */
export function deleteImageDatabase(): Promise<void> {
  return db.delete();
}

/**
 * Open a database
 */
export function openImageDatabase(): Promise<Dexie> {
  return db.open();
}

/**
 * Read all contacts
 */
export function readAllImages(): Promise<BlobImage[]> {
  return db.images.toArray();
}

/**
 * Delete all
 */
export function deleteAllImages(): Promise<void> {
  return db.images.clear();
}

/**
 * Create
 *
 */
export function createImage(image: BlobImage): Promise<string> {
  return db.images.put(image);
}

/**
 * Read an image
 */
export function readImageByID(id: string): Promise<BlobImage> {
  return db.images.get(id);
}

/**
 * Read images by URL
 */
export async function readImagesByURL(url: string): Promise<BlobImage[]> {
  return db.images
    .where('url')
    .equals(url)
    .toArray();
}

/**
 * Update image
 */
export function updateImage(image: BlobImage): Promise<string> {
  return db.images.put(image);
}

/**
 * Delete image
 */
export function deleteImage(id: string): Promise<number> {
  return db.images
    .where('id')
    .equals(id)
    .delete();
}
